/**
 * @component MitarbeiterListItem
 * @description Einheitliches Listen-Item fuer Mitarbeiter-Darstellungen.
 * Avatar + Name + berufsbezeichnung — abteilung_name + optional Trailing.
 * Referenz-Layout: siehe MitarbeiterPage (Table- und Card-View).
 *
 * @prop {object}  mitarbeiter  - { id, name, berufsbezeichnung, abteilung_name, foto_pfad, image_url, vorname, nachname, kuerzel }
 * @prop {'sm'|'md'|'lg'} [size='md']  - Avatar-Groesse (sm=32, md=40, lg=56)
 * @prop {boolean} [showSubtitle=true] - Untertitel anzeigen
 * @prop {function} [onClick]          - Klick-Handler (macht Row hoverbar)
 * @prop {node}    [trailing]          - Beliebiger Inhalt rechts
 * @prop {string}  [className]         - Zusaetzliche Klassen fuer den Wrapper
 * @prop {string}  [apiBase='']        - Optionaler API-Base (fuer Foto-URL)
 */
import MitarbeiterAvatar from './MitarbeiterAvatar';

const SIZE_MAP = { sm: 32, md: 40, lg: 56 };

export default function MitarbeiterListItem({
  mitarbeiter,
  size = 'md',
  showSubtitle = true,
  onClick,
  trailing,
  className = '',
  apiBase = '',
}) {
  if (!mitarbeiter) return null;

  const ma = mitarbeiter;
  const px = SIZE_MAP[size] || SIZE_MAP.md;
  const hasPhoto = !!(ma.foto_pfad || ma.image_url);
  const imageUrl = hasPhoto ? `${apiBase}/api/mitarbeiter/${ma.id}/foto` : null;

  const title = ma.berufsbezeichnung;
  const parts = [title, ma.abteilung_name].filter(Boolean);
  const subtitle = parts.join(' — ');

  const clickable = typeof onClick === 'function';

  return (
    <div
      onClick={clickable ? onClick : undefined}
      className={`flex items-center gap-3 min-w-0 ${clickable ? 'cursor-pointer' : ''} ${className}`}
    >
      <MitarbeiterAvatar imageUrl={imageUrl} name={ma.name} size={px} />
      <div className="flex-1 min-w-0">
        <div className="font-medium text-[var(--text-primary)] truncate">{ma.name}</div>
        {showSubtitle && subtitle && (
          <div className="text-xs text-[var(--text-tertiary)] truncate">{subtitle}</div>
        )}
      </div>
      {trailing && <div className="flex-shrink-0">{trailing}</div>}
    </div>
  );
}
